import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { HeaderProps } from './Header.types';
import classes from './Header.module.css';
import { IELTSLogoIcon } from '../../assets/icons';
import { Text } from '../Text/Text';
import { RootState } from '../../redux/store';

export const Header = (props: HeaderProps) => {
    const { className, sessionId } = props;
    const { insperaDetails } = useSelector((state: RootState) => state.appConfigSlice);
    const urlParams = new URLSearchParams(window.location.search);

    const productType = urlParams.get('productType');

    const showLogo = insperaDetails.product !== 'HOELT' && productType !== 'HOELT';

    return (
        <>
            {sessionId ? (<nav className={clsx(productType === "HOELT" ? classes.rootClassForHOELT : classes.root, className)}>
                <div className={classes.content}>
                    <IELTSLogoIcon className={classes.logo} data-testid="header-logo" visibility={showLogo ? 'visible' : 'hidden'} />

                    <Text text="Speaking test" variant="heading" fontWeight="semibold" className={classes.text} />
                </div>
            </nav>) : ''}
        </>
    );
};

Header.displayName = 'Header';
